import routePath from '@src/lib/routePath'

const base = `/retailer/business-settings/:retailerAccountSlug`

const retailerSettingsPaths = {
  index: routePath(base),
  businessInfo: routePath(`${base}/business-info` as const),
  socialAccounts: routePath(`${base}/social-accounts` as const),
  automations: routePath(`${base}/automations` as const),
  users: routePath(`${base}/users` as const),

  brandSettings: routePath(`${base}/brand-settings/:brandSlug?` as const),
  brandSettingsAutomations: routePath(
    `${base}/brand-settings/:brandSlug/automations` as const,
  ),
  brandSettingsLocations: routePath(
    `${base}/brand-settings/:brandSlug/locations` as const,
  ),
  brandSettingsWebsite: routePath(
    `${base}/brand-settings/:brandSlug/website` as const,
  ),
  brandSettingsQuestions: routePath(
    `${base}/brand-settings/:brandSlug/questions` as const,
  ),
}

export default retailerSettingsPaths
